export default __webpack_public_path__ + "static/media/me.f538281b.svg";